// extracted by mini-css-extract-plugin
module.exports = {"root":"NutrientSection_root__FTB2f","paragraph":"NutrientSection_paragraph__k_O1O"};